import { render, staticRenderFns } from "./StickersAdd.vue?vue&type=template&id=252deb19&scoped=true&"
import script from "./StickersAdd.vue?vue&type=script&lang=js&"
export * from "./StickersAdd.vue?vue&type=script&lang=js&"
import style0 from "./StickersAdd.vue?vue&type=style&index=0&id=252deb19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252deb19",
  null
  
)

export default component.exports